<template>
    <div class="webchat-forward-settings">
        <ChannelForwardSetting
            v-if="channel"
            :channel="channel"
            @input="handleInput"
            :group-chatbot-view="false"
            :enabled-zoho-transfer="false"
            class="webchat-specific-settings"
        />
        <div class="form-footer">
            <div class="actions">
                <a-button class="pr-confirm-btn" @click="handleSave" type="primary" :disabled="loading">
                    {{ $t("message.update") }}
                </a-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import ChannelForwardSetting from "../../../IntegrationChannelsItem/ChannelForwardSetting.vue";

export default {
    name: "WebChatDetails",
    components: {
        ChannelForwardSetting,
    },
    data() {
        return {
            channel: this.webChatChannel,
            loading: false,
        };
    },
    computed: {
        ...mapState({
            webChatChannel: (state) => state.channel.channels.find((channel) => channel.type === "webchat"),
        }),
    },
    mounted() {
        this.channel = this.webChatChannel;
    },
    methods: {
        ...mapActions({
            updateChannel: "channel/updateChannel",
            listChannels: "channel/listChannels",
        }),
        handleInput(channel) {
            console.log("WebChatDetails#handleInput", channel);
            this.channel = channel;
        },
        handleSave() {
            this.loading = true;
            this.updateChannel(this.channel)
                .then(() => {
                    this.listChannels();
                    this.$message.success("WebChat channel updated successfully.");
                })
                .catch((err) => {
                    console.error(err);
                    this.$message.error("Failed to update WebChat channel.");
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
    watch: {
        webChatChannel: {
            handler(channel) {
                this.channel = channel;
            },
            deep: true,
        },
    },
};
</script>

<style lang="scss">
.webchat-forward-settings {
    padding: 20px;

    .mode-card-content {
        flex-wrap: wrap;
        gap: 15px;
    }

    .mode-card {
        flex: 1 1 300px;
        min-height: 180px;
    }
}
</style>
